export enum RoadbookConfigurationIdentifier {
  AGENDA = 'AGENDA',
  CGV = 'CGV',
  CONTACTS = 'CONTACTS',
  EDITO = 'EDITO',
  FLIGHT = 'FLIGHT',
  ITINERARY = 'ITINERARY',
  OTHER_TRANSPORT_MODE = 'OTHER_TRANSPORT_MODE',
  PICTURE = 'PICTURE',
  PROGRAM = 'PROGRAM',
  ROADBOOK_CATEGORY = 'ROADBOOK_CATEGORY',
  GOOD_TO_KNOW = 'GOOD_TO_KNOW',
  STEPS = 'STEPS',
  SUMMARY = 'SUMMARY',
  VOUCHER = 'VOUCHER',
  FORMALITY = 'FORMALITY',
  GUIDE_DESTINATION = 'GUIDE_DESTINATION',
}